module.exports = __webpack_public_path__ + "img/hdnj-pic3.c45e7bd3.png";